module.exports = __webpack_public_path__ + "img/uptime.fb4944a.svg";